import { styled, SvgIcon } from '@mui/material';
const StyledSvgIcon = styled(SvgIcon)<{
  width: string;
  height: string;
}>(({
  width,
  height
}) => ({
  width,
  height
}));
export default StyledSvgIcon;